// extracted by mini-css-extract-plugin
export var avatar = "_qw-3";
export var avatarContainer = "_qw-2";
export var avatarSpacer = "_qw-5";
export var avatarSpacerContainer = "_qw-4";
export var avatarStackContainer = "_qw-1";
export var bubble = "_qw-0";
export var remainderBubble = "_qw-6";